import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-violation', {
        url: '/license-violation',
        component: 'companyLicenseViolation',
        resolve: {
        	licenseViolations
        },
    })
}



/** @ngInject */
function licenseViolations(companyId, LicenseViolationService) {
    return LicenseViolationService.licenseViolations.get({id: companyId}).$promise;
}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-violation/license-violation.state.js